export default __webpack_public_path__ + "image.6779a2a6.png";